// eslint-disable-next-line
<template>
  <div class="container narrow" style="margin-top:2rem">
    <template v-if="!loggedIn">
      <div v-html="pageContent"></div>
    </template>
    <ux-text-editor v-else @textupdate="saveData" :initContent="pageContent"></ux-text-editor>
  </div>
</template>

<script>
import UxTextEditor from "./UxTextEditor";
export default {
  components: { UxTextEditor },
  methods: {
    saveData(data) {
      this.$store.dispatch("saveText", data);
    }
  },
  created() {
    if (!this.pageContent) {
      this.$store.dispatch("setAboutText");
    }
  },
  computed: {
    pageContent() {
      return this.$store.state.about;
    },
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
div.container.narrow {
  min-width: unset;
  max-width: 700px;
  padding-right: 2rem;
  padding-left: 2rem;
  margin: 0 auto;
}
section.ux-image {
  margin: 2rem -2rem;
  display: flex;
  justify-content: center;
  /* flex-wrap: wrap; */
  .media {
    min-width: 0;
  }
  img {
    /* width: 450px; */
    max-width: 100%;
    max-height: 350px;
  }
}
</style>
